document.querySelectorAll(".custom-chip").forEach(function (chip) {
  chip.addEventListener("click", function () {
    chip.parentNode
      .querySelectorAll(".custom-chip")
      .forEach(function (sibling) {
        sibling.classList.remove("selected");
      });
    chip.classList.toggle("selected");
  });
});
